import { render, staticRenderFns } from "./repositories.vue?vue&type=template&id=e1553e62&scoped=true&"
import script from "./repositories.vue?vue&type=script&lang=js&"
export * from "./repositories.vue?vue&type=script&lang=js&"
import style0 from "./repositories.vue?vue&type=style&index=0&id=e1553e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1553e62",
  null
  
)

export default component.exports